<template>
  <div>
    <page-header
      icon="mdi-history"
      :title="
        toLatin($store.state.user.user.name) +
        ' ' +
        toLatin($store.state.user.user.lastname)
      "
      :subtitle="$t('order_history')"
    />
    <div
      class="hero"
      :style="`background: url('https://app.restorani.bitlab.host/gallery/${restaurant.id}/medium/${restaurant.settings.header}'); background-size: cover; background-position: center;`"
    >
      <img
        class="hero-logo"
        :src="
          conf.apiUrlBase + '/gallery/' + restaurant.id + '/' + restaurant.settings.logo
        "
      />
    </div>

    <v-container style="max-width: 1170px">
      <v-data-table
        dense
        class="ordera-box-shadow striped-table"
        :headers="headers"
        :items="meals"
        :loading="isLoadingHistory"
        @click:row="openDialog"
      >
        <template
          v-for="header in headers"
          v-slot:[`header.${header.value}`]="{ header }"
        >
          {{ translate(header.text) }}
        </template>
        <template v-slot:item.meals="{ item }">
          <p class="naziv-obroka">{{ translate(item.meals.name) }}</p>
        </template>
        <template v-slot:item.num="{ item, index }">
          {{ index + 1 }}
        </template>
      </v-data-table>

      <global-dialog-card :max-width="800" v-model="dialog" title="" hide-actions>
        <v-row>
          <v-col cols="12" sm="6">
            <v-img
              :src="
                selectedMeal.image
                  ? conf.apiUrlBase +
                    '/gallery/' +
                    restaurant +
                    '/medium/' +
                    selectedMeal.image.name
                  : './media/img/no-image.webp'
              "
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col cols="12" sm="6" class="ml-sm-n16 my-sm-2 mt-sm-16">
            <v-row align="end" class="fill-height">
              <v-card elevation="0" class="pa-5">
                <v-card-title
                  ><h3>
                    {{ translate(selectedMeal.meals.name) }}
                  </h3>
                </v-card-title>

                <v-card-text class="mb-4">
                  <v-row no-gutters>
                    <template v-for="(eat, i) in selectedMeal.meals.foods">
                      <v-col cols="12" class="font-weight-bold pt-2">
                        <v-row no-gutters justify="space-between">
                          <span>
                            <h3>{{ translate(eat.name) }}</h3>
                          </span>
                        </v-row>
                      </v-col>
                      <v-col cols="12">{{ translate(eat.description) }}</v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </global-dialog-card>
    </v-container>
  </div>
</template>

<script>
import conf from "@/config";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";

export default {
  mixins: [hasSnackbar],
  data() {
    return {
      meals: [],
      dialog: false,
      conf: conf,
      selectedMeal: { meals: { name: null, foods: {} } },
      counter: 0,
      isLoadingHistory: false,
      headers: [
        {
          text: this.$t("serial_number"),
          value: "num",
        },
        {
          text: this.$t("date"),
          value: "date",
        },
        {
          text: this.$t("shift.shift"),
          value: "shift",
        },
        {
          text: this.$t("meal"),
          value: "meals",
        },
      ],
    };
  },
  computed: {
    restaurant() {
      return this.$store.state.restaurant
        ? this.$store.state.restaurant
        : this.$store.state.company.restaurant;
    },
  },
  created() {
    this.isLoadingHistory = true;
    userService
      .getUserHistory()
      .then((res) => {
        let modified = [];
        res.data.forEach((element) => {
          element.shift = element.shift.replace("-smena", "");
          modified.push(element);
        });

        this.meals = modified;
      })
      .catch((error) => {
        this.showErrorSnackbar(error, this.$t("error_loading_history"));
      })
      .finally(() => {
        this.isLoadingHistory = false;
      });
  },
  methods: {
    openDialog(item) {
      this.dialog = true;
      this.selectedMeal = item;
    },
  },
};
</script>

<style scoped>
/* .row {
  width: 100%;
} */

.istorija-header {
  font-weight: bold;
  font-size: 19px;
}

.red-istorija {
  cursor: pointer;
}

.red-istorija p {
  margin: 0;
  padding: 0;
}

.red-istorija:nth-child(odd) {
  background: #f3f4f4;
}

.naziv-obroka {
  cursor: pointer;
  transition: all 0.2s;
  margin: 0;
  width: max-content;
  padding: 5px 15px;
}

.naziv-obroka:hover {
  font-weight: bold;
  background: #ededed;
  padding: 5px 14px;
  width: max-content;
}
</style>
